<template>
  <el-select v-model="value" @change="handleChange" class="w-full" :placeholder="t('common.selectCountry')" filterable>
    <template #prefix>
      <span v-if="value" class="mr-1 text-2xl leading-none">
        {{ selectedCountry?.flag }}
      </span>
    </template>
    <el-option
      v-for="country in sortedCountries"
      :key="country.code"
      :label="country.name[unref(locale) === 'zh' ? 'zh' : 'en']"
      :value="country.code"
    >
      <div class="flex items-center h-[50px]">
        <span class="mr-2 text-2xl leading-none">{{ country.flag }}</span>
        <span class="text-xl leading-none">{{ country.name[unref(locale) === 'zh' ? 'zh' : 'en'] }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script lang="ts" setup>
import { ref, computed, unref } from 'vue';
import { useI18n } from 'vue-i18n';
import { countries } from './countries';

const { t, locale } = useI18n();

const $props = defineProps<{
  modelValue?: string;
}>();

const $emit = defineEmits(['change', 'update:modelValue']);
const value = ref($props.modelValue);

// 按照当前语言的国家名称排序
const sortedCountries = computed(() => {
  return [...countries].sort((a, b) => {
    const lang = unref(locale) === 'zh' ? 'zh' : 'en';
    return a.name[lang].localeCompare(b.name[lang]);
  });
});

const selectedCountry = computed(() => {
  return countries.find(country => country.code === value.value);
});

const handleChange = () => {
  $emit('change', value.value);
  $emit('update:modelValue', value.value);
};
</script>

<style lang="scss" scoped>
:deep(.el-select-dropdown__item) {
  padding: 0 12px;
  height: 50px;
  line-height: 50px;
}
</style>
